import React, { Component } from 'react'
import OLDragBox from 'ol/interaction/dragbox';
import ol_condition from 'ol/events/condition';

class DragBox extends Component {
  constructor(props) {
    super(props)

    this.dragBox = new OLDragBox({
      condition: ol_condition.never
    })
    this.dragBox.on('boxend', props.onBoxEnd);
    props.mapInstance.addInteraction(this.dragBox);
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this.props.mapInstance.removeInteraction(this.dragBox);
  }

  render() {
    return null;
  }
}

export default DragBox;



// WEBPACK FOOTER //
// ./src/components/ol/interactions/DragBox.js